import { Credit } from "v3/services/graphql/generated";
import { SavedPaymentMethodsType } from "v3/types/payment";

export const getIsOrderMoreThanAllocationAmount = ({
  paymentMethods,
  totalPrice,
}: {
  paymentMethods: SavedPaymentMethodsType;
  totalPrice: number | undefined;
}) => {
  const allocationCreditPaymentMethod = paymentMethods.find(
    (paymentMethod): paymentMethod is Credit =>
      paymentMethod.__typename === "Credit"
  );
  if (allocationCreditPaymentMethod) {
    const isOrderMoreThanAllocationAmount =
      totalPrice === undefined
        ? false
        : allocationCreditPaymentMethod.availableAmount < totalPrice;
    return isOrderMoreThanAllocationAmount;
  }
  return false;
};
